module.exports = __webpack_public_path__ + "static/media/bannerimg2.df50a04f.jpg";